import { render, staticRenderFns } from "./MuzRussiaComment.vue?vue&type=template&id=9708f408&"
import script from "./MuzRussiaComment.vue?vue&type=script&lang=ts&"
export * from "./MuzRussiaComment.vue?vue&type=script&lang=ts&"
import style0 from "./MuzRussiaComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports